module.exports = __webpack_public_path__ + "img/objects-align-right.1a787c25.svg";